import {Routes, Route} from "react-router-dom";
import ConsolidatedBudgetInfoSection from "./sections/ConsolidatedBudgetInfoSection";

function ConsolidatedBudgetApp() {
    const data = JSON.parse(localStorage.getItem("userData") as string);

    return (
        <Routes>
            {!data.isCustomer && (
                <>
                    <Route path='/' element={<ConsolidatedBudgetInfoSection/>}/>
                </>
            )}
        </Routes>
    );
}

export default ConsolidatedBudgetApp;
